(() => {
  if (window.__headerMenuProductModalInit) return;
  window.__headerMenuProductModalInit = true;

  const getModal = () => document.querySelector('[data-header-menu-product-modal]');

  const closeModal = (modal = getModal()) => {
    if (!modal) return;
    const content = modal.querySelector('[data-header-menu-product-content]');
    modal.classList.remove('is-active');
    modal.hidden = true;
    if (content) content.innerHTML = '';
    document.body.classList.remove('overflow-hidden');
  };

  const openModal = (templateId) => {
    const template = document.getElementById(templateId);
    const modal = getModal();
    const content = modal?.querySelector('[data-header-menu-product-content]');
    if (!template || !modal || !content) return;

    content.innerHTML = template.innerHTML;
    modal.hidden = false;
    modal.classList.add('is-active');
    document.body.classList.add('overflow-hidden');

    const checkedOption = content.querySelector('[data-header-menu-product-option]:checked');
    if (checkedOption) {
      checkedOption.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-header-menu-product-open]');
    if (openButton) {
      event.preventDefault();
      openModal(openButton.dataset.productTemplate);
      return;
    }

    const closeButton = event.target.closest('[data-header-menu-product-close]');
    if (closeButton) {
      event.preventDefault();
      closeModal(closeButton.closest('[data-header-menu-product-modal]'));
      return;
    }

    const quantityMinus = event.target.closest('[data-header-menu-quantity-minus]');
    const quantityPlus = event.target.closest('[data-header-menu-quantity-plus]');
    if (quantityMinus || quantityPlus) {
      event.preventDefault();
      const quantity = event.target
        .closest('[data-header-menu-quantity]')
        ?.querySelector('input[name="quantity"]');
      if (!quantity) return;
      const currentValue = Number(quantity.value) || 1;
      quantity.value = quantityPlus ? currentValue + 1 : Math.max(1, currentValue - 1);
    }
  });

  document.addEventListener('change', (event) => {
    const headerOption = event.target.closest('[data-header-menu-product-option]');
    if (!headerOption) return;

    const form = headerOption.closest('[data-header-menu-product-form]');
    const price = form?.querySelector('[data-header-menu-modal-price]');
    const compare = form?.querySelector('[data-header-menu-modal-compare]');
    const savings = form?.querySelector('[data-header-menu-modal-savings]');

    if (price && headerOption.dataset.price) price.textContent = headerOption.dataset.price;

    if (compare) {
      compare.textContent = headerOption.dataset.compare || '';
      compare.hidden = !headerOption.dataset.compare;
    }

    if (savings) {
      savings.textContent = headerOption.dataset.savings || '';
      savings.hidden = !headerOption.dataset.savings;
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-header-menu-product-form]');
    if (!form) return;

    event.preventDefault();
    const submit = form.querySelector('[type="submit"]');
    const radio = form.querySelector('[data-header-menu-product-option]:checked');
    const quantity = form.querySelector('input[name="quantity"]');
    if (!submit || !radio || submit.disabled) return;

    submit.disabled = true;
    submit.setAttribute('aria-disabled', 'true');

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const item = {
      id: Number(radio.value),
      quantity: quantity ? Number(quantity.value) || 1 : 1,
    };

    if (radio.dataset.sellingPlan) {
      item.selling_plan = Number(radio.dataset.sellingPlan);
    }

    const payload = { items: [item] };
    if (cart) {
      payload.sections = cart.getSectionsToRender().map((section) => section.id).join(',');
      payload.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(submit);
      }
    }

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) throw new Error(response.description || 'cart_add_failed');

        closeModal();

        if (cart && response.sections) {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(response);

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'header-menu-desktop',
              cartData: response,
            });
          }
          return;
        }

        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      })
      .catch(() => {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      })
      .finally(() => {
        submit.disabled = false;
        submit.removeAttribute('aria-disabled');
      });
  });

  document.addEventListener('keyup', (event) => {
    if (event.code !== 'Escape') return;
    const modal = document.querySelector('[data-header-menu-product-modal].is-active');
    if (modal) closeModal(modal);
  });
})();

/****** Mega menu related card link test *******/
document.addEventListener("click", (event) => {
  const card = event.target.closest(".mega-menu__related-card");
  if (!card) return;
  // No hacer nada si se hizo click en un botón o enlace
  if (event.target.closest("a, button")) return;
  window.location.href = card.dataset.productUrl;
});